import styled from "styled-components";
import { FormTitle, Input, SubmitButton } from "../limit-order-form/styles";

export const PositionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%; // Full width to use the available space
  max-width: 600px; // Set a max-width to ensure it doesn't get too wide on larger screens
  margin: 2rem auto; // More vertical margin to center on the page with space on the top and bottom
  padding: 1rem;
  gap: 1rem;
  box-sizing: border-box;
  background-color: #f7f7f7; // A light background to distinguish from the page background
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); // Subtle shadow to lift the container
`;

export const PositionCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem; // Consistent spacing between cards
  padding: 1rem;
  width: 100%; // Card width fills the container
  box-sizing: border-box; // Include padding and border in the width and height
  display: flex;
  flex-direction: column;
  align-items: flex-start; // Align text to the start
`;

// Assuming you're using a modern version of styled-components:
export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%; // Ensure the full width is used for alignment
  padding: 0.5rem 0; // Padding on top and bottom of each row for space
`;

// Rest of your styled components remain unchanged

export const CardLabel = styled.span`
  color: #333;
  font-size: 0.9rem;
  font-weight: bold; // Make label bold to differentiate from value
  text-align: left;
`;

export const CardValue = styled.span`
  color: #333;
  font-size: 0.9rem;
  text-align: right;
`;

export const CardTitle = styled(FormTitle)`
  // Inherits styles from FormTitle
`;

export const CancelButton = styled(SubmitButton)`
  // Inherits styles from SubmitButton
  background-color: #ff6b6b;
  margin-top: 1rem;

  &:hover {
    background-color: #e53e3e;
  }
`;

// Adjusted styles for input elements to match read-only data display
export const ReadOnlyInput = styled(Input)`
  background-color: #edf2f7;
  pointer-events: none;
  color: #333;
`;

export const Tabs = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem; // Provide some space between the tabs and the content below
  background-color: #f1f1f1; // A subtle background to differentiate the tab area
  border-radius: 8px; // Smooth out the corners
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); // Soft shadow for depth
`;

export const Tab = styled.button`
  flex-grow: 1;
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  outline: none;
  background-color: ${(props) => (props.active ? "#ffffff" : "transparent")};
  border-bottom: ${(props) => (props.active ? "3px solid #666666" : "none")};
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => (props.active ? "#333333" : "#777777")};
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #ffffff;
    color: #333333;
  }

  // Ensure that tabs are evenly spaced and visually separated
  &:not(:last-child) {
    border-right: 1px solid #dddddd;
  }
`;
